import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SavingsIcon from '@mui/icons-material/Savings';
import SpeedIcon from '@mui/icons-material/Speed';
import SectionHeading from './SectionHeading';
import CardGrid from './CardGrid';
import { brandColors } from '../theme';
import { fillCard } from '../styles/alignedCards';

const outcomes = [
  {
    icon: <SavingsIcon fontSize="large" />,
    title: 'Menos costo operativo',
    text: 'Menos horas en tareas manuales y menos errores costosos.',
  },
  {
    icon: <TrendingUpIcon fontSize="large" />,
    title: 'Más ingresos',
    text: 'Mejor visibilidad para vender, operar y priorizar lo que genera valor.',
  },
  {
    icon: <SpeedIcon fontSize="large" />,
    title: 'Decisiones más rápidas',
    text: 'Datos confiables y procesos que responden en tiempo real.',
  },
];

const Outcomes = () => (
  <Box
    component="section"
    id="outcomes"
    sx={{
      py: { xs: 6, md: 8 },
      background: `linear-gradient(180deg, #fff 0%, ${brandColors.ice} 100%)`,
    }}
  >
    <Container maxWidth="lg">
      <SectionHeading
        label="Resultados"
        title="El impacto que buscamos con cada proyecto"
        subtitle="No vendemos tecnología por moda: medimos el éxito en ahorro, eficiencia y crecimiento."
      />
      <CardGrid columns={{ xs: 1, md: 3 }} gap={{ xs: 2, md: 3 }}>
        {outcomes.map((item) => (
          <Paper
            key={item.title}
            elevation={0}
            sx={{
              ...fillCard(),
              p: 3,
              textAlign: 'center',
              border: `1px solid ${brandColors.mist}`,
            }}
          >
            <Box sx={{ color: brandColors.gold, mb: 1.5 }}>{item.icon}</Box>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              {item.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {item.text}
            </Typography>
          </Paper>
        ))}
      </CardGrid>
    </Container>
  </Box>
);

export default Outcomes;
